import { defineComponent, computed } from 'vue';
import ExactLogo from '../../../assets/logos/exact-logo.svg.js';
import Logo from '../../../assets/logos/logo.svg.js';
import __vue_component__ from '../../transitions/TransitionFadeOutIn/TransitionFadeOutIn.vue.js';
import { LoadingStyle } from './model.js';

var script = defineComponent({
    name: 'Loading',
    components: {
        Logo,
        ExactLogo,
        TransitionFadeOutIn: __vue_component__,
    },
    model: {
        prop: 'active',
        event: 'update:active',
    },
    props: {
        active: Boolean,
        canCancel: Boolean,
        isFullPage: {
            type: Boolean,
            default: true,
        },
        dark: Boolean,
        loadingStyle: {
            type: String,
            default: 'default',
        },
        message: {
            type: String,
            default: null,
        },
        opaque: Boolean,
        standalone: Boolean,
        transparent: Boolean,
    },
    setup(props) {
        const classNames = computed(() => {
            const names = [];
            if (props.transparent)
                names.push('Loading--transparent');
            else if (props.opaque)
                names.push('Loading--opaque');
            else
                names.push('Loading--translucent');
            if (props.standalone)
                names.push('Loading--standalone');
            else if (props.isFullPage)
                names.push('Loading--full-page');
            if (props.dark)
                names.push('Loading--dark');
            switch (props.loadingStyle) {
                case LoadingStyle.DEFAULT:
                    names.push('Loading--default');
                    break;
                case LoadingStyle.APP_INIT:
                    names.push('Loading--app-init');
                    break;
            }
            if (props.message)
                names.push('Loading--has-message');
            return names;
        });
        const showLogo = computed(() => props.loadingStyle === LoadingStyle.APP_INIT);
        const theme = computed(() => document.documentElement.getAttribute('data-theme'));
        return {
            classNames,
            showLogo,
            theme,
        };
    },
});

export { script as default };
